var noop = function noop() {};

export default noop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/noop.js
// module id = 277
// module chunks = 0 1 2 3 4 5 6 7